import {useEffect} from 'react';

import adminDashboardHero from 'assets/images/admin-dashboard-hero.svg';
import {useGlobalState} from 'hooks/useGlobalState';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router';
import {getAdminDashboardDataACS} from 'store/app/appSlice';

import TopItems from '../TopItems/TopItems';
import Balloon from './Balloon/Balloon';

import './AdminPage.scss';

const AdminPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const dashboardStats = useGlobalState((state) => state.app.adminDashboardData);

  useEffect(() => {
    dispatch(getAdminDashboardDataACS());
  }, [dispatch]);

  return (
    <div className="admin-page">
      <div className="admin-page__hero">
        <div className="admin-page__hero-image-wrapper">
          <img className="admin-page__hero-image" src={adminDashboardHero} alt="Admin dashboard hero" />
          {dashboardStats && (
            <>
              <Balloon
                className="admin-page__balloon-pubs"
                title="Pubs"
                count={dashboardStats.pubs_count}
                onClick={() => navigate('/pub-pages')}
              />
              <Balloon
                className="admin-page__balloon-beers"
                title="Beers"
                count={dashboardStats.beers_count}
                onClick={() => navigate('/beers')}
              />
              <Balloon
                className="admin-page__balloon-users"
                title="App Users"
                count={dashboardStats.users_count}
                onClick={() => navigate('/editors')}
              />
              <Balloon
                className="admin-page__balloon-beer-styles"
                title="Beer Styles"
                count={dashboardStats.beer_styles_count}
                onClick={() => navigate('/beer-styles')}
              />
              <Balloon
                className="admin-page__balloon-breweries"
                title="Breweries"
                count={dashboardStats.breweries_count}
                onClick={() => navigate('/breweries')}
              />
            </>
          )}
        </div>
      </div>
      <TopItems />
    </div>
  );
};

export default AdminPage;
